// The financing line and the HSA line, trimmed to the wording the working file
// asks for: "$43.09 /mo with shop   HSA/FSA eligible  Save 30%".
//
// Neither line is ours. Shopify renders the first inside a shadow root and
// Truemed injects the second from its own script, so there is nothing in Liquid
// to edit — the only way in is to reach the nodes once they exist. Both are
// rewritten in place rather than replaced, so the Shop Pay mark and the HSA
// badge stay the ones their owners drew.
//
// Everything here fails open. A piece that is not where it was left alone, so a
// change at either end leaves the buyer with the full sentence rather than a
// broken one.

const PAY_ROW_SELECTOR = "#apex-pay-row";

// Shopify writes "From $43.09/mo or 0% APR with [Shop]". The price and the mark
// are kept as they are; everything between them is this one phrase.
const perMonthWording = () =>
  window.translations?.apex_pay_row?.per_month || "/mo with";

const trimInstallments = (row) => {
  const terms = row.querySelector("shopify-payment-terms");
  const content = terms?.shadowRoot?.querySelector("#shopify-installments-content");
  if (!content || content.dataset.apexTrimmed === "true") return;

  // The bold figure and the Shop mark are the two things worth keeping, and the
  // element is only safe to rewrite while both are found.
  const price = content.querySelector(".font-bold");
  const mark = content.querySelector("svg")?.closest("div") ?? content.querySelector("div");
  if (!price || !mark) return;

  const connector = document.createElement("span");
  connector.textContent = ` ${perMonthWording()} `;

  content.replaceChildren(price, connector, mark);
  content.dataset.apexTrimmed = "true";

  // The button beside it opens the Shop Pay terms. The working file does not
  // draw it; take this line out and it comes back.
  const termsButton = terms.shadowRoot.querySelector("#shopify-installments-cta");
  if (termsButton) termsButton.style.display = "none";
};

// "Save an average of 30%" says the same thing as "Save 30%" in half the room,
// and room is what this row is short of.
const shortenHealthSavings = (row) => {
  row.querySelectorAll(".truemed-entry-text").forEach((element) => {
    if (element.dataset.apexTrimmed === "true") return;
    const shortened = element.textContent.replace(/\ban average of\s+/i, "");
    if (shortened === element.textContent) return;
    element.textContent = shortened;
    element.dataset.apexTrimmed = "true";
  });
};

const tidy = (row) => {
  trimInstallments(row);
  shortenHealthSavings(row);
};

const watch = (row) => {
  tidy(row);

  // Both widgets arrive late and redraw themselves when the variant changes, so
  // the row is watched rather than tidied once. The flags above keep the work
  // down to a read on every pass but the first.
  new MutationObserver(() => tidy(row)).observe(row, { childList: true, subtree: true });

  // A shadow root is its own tree and does not show up in the mutations above.
  // Shopify fills it after the element upgrades, hence the wait.
  customElements.whenDefined?.("shopify-payment-terms").then(() => {
    let attempts = 0;
    const poll = setInterval(() => {
      trimInstallments(row);
      attempts += 1;
      const done = row.querySelector("shopify-payment-terms")?.shadowRoot
        ?.querySelector("#shopify-installments-content")?.dataset.apexTrimmed === "true";
      if (done || attempts > 40) clearInterval(poll);
    }, 250);
  });
};

const start = () => {
  const row = document.querySelector(PAY_ROW_SELECTOR);
  if (row) watch(row);
};

window._sections = window._sections || {};
window._sections["watchPayRow"] = watch;

document.addEventListener("DOMContentLoaded", start);
if (document.readyState !== "loading") start();
